import { Component, OnInit } from '@angular/core';
import { SharedService } from 'src/app/core/services/shared.service';

@Component({
  selector: 'app-menu-lateral',
  templateUrl: './menu-lateral.component.html',
  styleUrls: ['./menu-lateral.component.scss']
})
export class MenuLateralComponent implements OnInit {

  constructor(private dataService: SharedService) { }
  menuItems;
  public isCollapsed = false;
  
  ngOnInit(): void {
      this._fetchData('{}');
  }

  /**
   * fetches the menu value
   */

  _fetchData(filtros: string) {
    this.dataService.ConsultarWS("api/core/MenuReportes", filtros).subscribe(
      (datosResp: any) => {
        this.menuItems = datosResp.MENU;
      });
  }

  AbrirNuevoTab(){}
}
